(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kbagro-contact"] && !Shopify.designMode) return;
  try {
    
  class KBAgroContact {
    constructor(section) {
      this.section = section;
      this.initIntersectionObserver();
    }

    initIntersectionObserver() {
      const options = {
        threshold: 0.1,
        rootMargin: '50px'
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.style.animationPlayState = 'running';
            observer.unobserve(entry.target);
          }
        });
      }, options);

      this.section.querySelectorAll(
        '.kbagro-contact__card, .kbagro-contact__map-container, .kbagro-contact__gallery-item'
      ).forEach(el => {
        observer.observe(el);
      });
    }
  }

  document.addEventListener('shopify:section:load', function(e) {
    new KBAgroContact(e.detail.section);
  });

  if (document.readyState !== 'loading') {
    document.querySelectorAll('.kbagro-contact').forEach(section => {
      new KBAgroContact(section);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
